import React from 'react';
import LoaderComponent from './loader.component';
function Loader(props) {
    return <LoaderComponent {...props}></LoaderComponent>;
}

export default Loader;
